ele.modal = (function(){

	var listInit = false;

	/*
	 * base config 
	 * 
	 * any of these can be overwritten either using an alternative 
	 * .init() in your sites custom js. (Designed so you can call
	 * init more than once without screwing up the listeners). A neater solution
	 * may to use the option() method but both will work. Please don't start mucking 
	 * around with widths in the CSS. Heights will auto calculate based on content.
	 * 
	 * example:
	 * ele.modal.option("hide", 150);
	 * ele.modal.option("show", 150);
	 * 
	 * example:
	 * ele.modal.init({'width': 900, 'widthSmall': 500})
	 * 
	 */
	var config = {
		/* draggable disabled by default as the css to get it to work 
		 * would muck up some sites. Enabling it will allow confirms/prompts 
		 * to be draggable */
		draggable: false,
		
		/* the hide animation for the dialog. takes a number for face duration
		* or null for no fade */
		hide: null,	
		
		/* resizable disabled by default (just because its not needed) */
		resizable: false,
		
		/* the hide animation for the dialog. takes a number for face duration
		* or null for no fade */
		show: null,	
		
		/* width for big modals */
		width: function(){
            $(window).width()
		    return 770
        },
		
		/* width for small modals */
		widthSmall: 420,
		
		/* width (size attr) for text inputs */
		widthTextInput: 60
	}
	
	return {
		
		init: function(userConfig){ 
			
			//load in custom config
			jQuery.extend(config, userConfig);
			
			if (listInit == false) {
				
				listInit = true;
				
				//initialise the modals that are based listeners on objects containing certain classes
				//This modal loads an external page HTML and puts it into the content!
				$("body").on("click", '.mdlAjaxCPageTrigger, .mdlAjaxTBYBTrigger', function() {
					var link = $(this);
					if(typeof link.attr('href') != 'undefined'){
                        var tUrl = link.attr('href');
                    } else {
                        var tUrl = link.data('href');
                    }
					var url = tUrl + (tUrl.indexOf("?") === -1 ? "?" : "&") + "modal=1";
					var $content = $('<div></div>')
					.load(url, function() {
						let $dialog = ele.modal.create({
							content: $content,
					    	dialogClass: "e_modalFullText",
							title: link.data('mdltitle')
						});
				    	$dialog.dialog("open");
					});
				    return false;
				});

				// This loads bulletin articles (which are objects on cpages) in to modals.
                $("body").on("click", '.mdlBulletinArticleTrigger', function() {
                    var link = $(this);
                    
                    // Check if this link is already loading
                    if (link.hasClass('loading-bulletin')) {
                        return false;
                    }
                    
                    var tUrl = link.data('href');
					if(typeof tUrl == 'undefined'){
						tUrl = link[0].href;
					}
                    var CMSParent = link.data('parent');
                    var url = tUrl + (tUrl.indexOf("?") === -1 ? "?" : "&") + "ajax=1";
                    
                    // Mark as loading to prevent multiple requests
                    link.addClass('loading-bulletin');
                    
                    $.get( url, function( data ) {
                        var articleObject = JSON.parse(data);
                        var $dialog = ele.modal.create({
                            content: $('<div></div>').append(articleObject.content),
                            dialogClass: "e_modalFullText bulletinArticleModal",
                            title: articleObject.title,
                            buttons: [{
                                'class': "btn-secondary float-right mt-2",
                                text: "Print",
                                click: function () {
                                    $('.bulletinArticleModal').addClass('print');
                                    ele.print.printContent('.bulletinArticleModal');
                                    $dialog.dialog("close");
                                }
                            },{
                                'class': "btn-secondary float-right mt-2 mr-2",
                                text: "Download as a PDF",
                                click: function () {
                                    let destination = ele.uri.buildUrl("bulletinArticlePDF", {articleID: CMSParent});
                                    window.location.href = destination;
                                }
                            },{
                                'class': "btn-secondary mt-2",
                                text: "Close",
                                click: function () {
                                    $dialog.dialog("close");
                                }
                            }]
                        });
                        $dialog.dialog("open");
                    }).always(function() {
                        // Remove loading state regardless of success/failure
                        link.removeClass('loading-bulletin');
                    });
                    return false;
                });
				
				//this modal loads page into an iframe!
				$("body").on("click", '.mdlAjaxIframeTrigger', function() {
					var link = $(this);
					var tUrl = link.data('href');
					var url = tUrl + (tUrl.indexOf("?") === -1 ? "?" : "&") + "modal=1";
					var $content = $('<div><iframe id="e_modalIframeContent" frameborder="0" src="'+url+'" height="'+Math.round($(window).height() / 1.15)+'" /></div>');
					
					var $dialog = ele.modal.create({
					    dialogClass: "e_modalIframe",
					    content: $content,
						title: link.attr('title')
					});
					$dialog.dialog("open");
					$("#e_modalIframeContent").attr("height",parseInt($content.height())-5);
					return false;
				});

				$("body").on("click", '#featuresAndBenefitsModalAboutTrigger', function() {
					var link = $(this);
					var source = $(this).data('about-text');
					var title = $(this).data('title');
					var $content = $(
						'<div class="about-text">'+ source + '</div>'
					);
					var $dialog = ele.modal.create({
					    dialogClass: "featuresAndBenefitsModal",
					    content: $content,
						title: title,
					});
					$dialog.dialog("open");
					return false;
				});
				
				$("body").on("click", '#featuresAndBenefitsModalVideoTrigger', function() {
					var link = $(this);
					var source = $(this).data('wistia-id');
					var title = $(this).data('title');
					var $content = $(
						'<div class="video-container">' +
						'<script src="https://fast.wistia.com/player.js" async></script>' +
						'<script src="https://fast.wistia.com/embed/'+source+'.js" async type="module"></script>' +
						"<style>wistia-player[media-id='"+source+"']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/"+source+"/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }</style>" +
						'<wistia-player media-id="'+source+'" aspect="1.7777777777777777"></wistia-player>' +
						'</div>'
					);
					var $dialog = ele.modal.create({
					    dialogClass: "featuresAndBenefitsModal",
					    content: $content,
						title: title,
					});
					$dialog.dialog("open");
					return false;
				});
	
				//this modal takes a div on the page and loads it in to the content!
				$("body").on("click", '.mdlHtmlTrigger', function() {
					var target = $(this);
					var source = $($(this).data('mdlsource'));
					
					var $dialog = source
						.dialog({
							autoOpen: false,
					    	dialogClass: "e_modalFullText",
							draggable: config.draggable,
							hide: config.hide,
							open: function(){
								ele.modal.resize($dialog);
							},
							modal: true,
							resizable: config.resizable,
							show: config.show,
							title: target.data('mdltitle'),
						});
					
					$dialog.dialog("open");
					return false;
				});
			}
		},
		
		/* set an option individually */
		option: function(option, value) {
			config[option] = value;			
		},
		
		/* closes all open modals */
		closeAll:function(){
    		$(".ui-dialog-titlebar-close").click();
		},
		
		/* functions for dialogs "prompt" and "confirm" used in My Documents */
		prompt: function(args, callback) {

			//make our message container
			var content = $('<div></div>');
			content.html(args.message);
			
			//out input whose val will go into the callback;
			var input, form, label, submit;
			
			if (args.inputType == 'select') { //add a select dropdown
				//prepare the options
				var optionFields = "";
				if (args.inputList.length == 0) {
					//there are no options :(
					content.html("There are no available folders"); //this shouldn't be here - make more generic
				}
				else {
					//load all the options into the dropdown
					$.each(args.inputList, function(key, value) {
						optionFields += '<option value="' + key + '">' + value + '</option>';	
					});
					input = $('<select class="e_modalSelect" name="modalSelect" id="modalSelect"></select>').html(optionFields);
					label = $('<label style="display:none" for="modalSelect">Please select an option</label>');
				}
			}
			else if (args.inputType == 'textarea') { //add a select dropdown
				var defaultText = args.defaultVal;
				if (defaultText == undefined) { defaultText = ""; }
				input = $('<textarea class="e_modalText" id="modalText" name="modalText" cols="'+config.widthTextInput+'">'+defaultText+'</textarea>');
                label = $('<label style="display:none" for="modalText">Please enter your text</label>');
			}
			else //otherwise, add a text field
			{
				var defaultText = args.defaultVal;
				if (defaultText == undefined) { defaultText = ""; }
				input = $('<input type="text" class="e_modalText" id="modalText" name="modalText" value="'+defaultText+'" size="'+config.widthTextInput+'" />');
                label = $('<label style="display:none" for="modalText">Please enter your text</label>');
			}
			
			submit = $('<button type="submit" class="sr-only">Submit</button>');

			form = $('<form id="modalForm" action="#" />').append(label).append(input).append(submit);
			
			form.appendTo(content);
			
			//prepare the dialog
			var $dialog = 
				ele.modal.create({
					buttons: [
                    {
                        'class':"e_cancel",
                        text: i18n("js_cancel"),
                        click: function() {
                            $(this).dialog("close");
                        }
                    },{
                        'class':"e_ok",
                        text: i18n("js_ok"),
                        click: function() {
                            if ($(this).find('form').valid()) {
                                if (callback !== undefined) callback(input.val());
                                $(this).dialog("close");
                            }
                        }
                    }],
                    content: content,
				    dialogClass: "e_modalDialog",
					title: args.title,
					width: config.widthSmall
				});
			$dialog.dialog("open");

			form.submit(function(ev){
				ev.preventDefault();
				if ($(this).valid()) {
					if (callback !== undefined) callback(input.val());
					$dialog.dialog("close");
				}
			});

			return $dialog;
		},
		
		confirm: function(message, callback, cancelCallback, args) {
			//make our message container
			var content = $('<div></div>');
			content.html(message);

            var title = ""
            if (typeof(args) != 'undefined'){
                if (typeof(args.title) != 'undefined') {
                    title = args.title;
                }
            }

			var $dialog =
				ele.modal.create({
					buttons: [{
                        'class':"e_cancel",
                        text: i18n("js_cancel"),
                        click: function() {
                        	if (cancelCallback !== undefined) cancelCallback();
                            $(this).dialog("close");
                        }
                    },{
                        'class':"e_ok",
                        text: i18n("js_ok"),
                        click: function() {
                            if (callback !== undefined) callback();
                            $(this).dialog("close");
                        }
                    }],
                    content: content,
				    dialogClass: "e_modalConfirm",
					width: config.widthSmall,
                    title: title
				});
			$dialog.dialog('open');
			return $dialog;
		},
		
		/** 
		 * more complex create method for dialogs that still handles a few minor bits
		 * importantly resizing along with the window resize event + removing itself properly from the DOM 
		 * and event listeners
		 */
		create: function(args) {

            args = $.extend("", config, args);

            var uniqueNum = Math.floor(Math.random() * 99999);

            //init a big modal and put content into it - return the instance of the modal
            var $dialog = $(args.content).dialog({
                autoOpen: false,
                buttons: args.buttons,
                close: function () {
                    $(window).unbind('resize.modalResize' + uniqueNum);
                    if (args.close !== undefined && args.close !== null) args.close();
                    if ($(this).parent().hasClass('ui-dialog')) $(this).dialog('destroy');
                },
                closeText: i18n('js_close'),
                dialogClass: args.dialogClass,
                draggable: args.draggable,
                hide: args.hide,
                open: function () {
                    $(this).scrollTop(0); /* autofocus fix */
                },
                modal: true,
                show: args.show,
                resizable: args.resizable,
                title: "",
                width: ele.modal.getWidth(),
                position: {my: "top", at: "top+10%", of: window},
                closeOnEscape: false
            });

            if (typeof (args) != 'undefined') {
                if (typeof (args.title) != 'undefined') {
                    if (args.title != '') {
                        if($('.modal-title-custom h2').length) {
                            $('.modal-title-custom').attr('modal-title-custom');
                            $('.modal-title-custom h2').text(args.title);
                        } else {
                            $(args.content).before('<div id="modal-title-custom" class="modal-title-custom"><h2>' + args.title + '</h2></div>');
                        }
                    }
                }
            }

            // WCAG
            $('.ui-dialog-titlebar-close').attr('aria-label', 'Close this modal');
            $('.ui-dialog').attr('aria-labelledby', 'modal-title-custom');

            ele.modal.resize($dialog);

            // when the
            $(window).bind('resize.modalResize' + uniqueNum, function (e) {
                try {
                    ele.modal.resize($dialog);
                } catch (err) {
                    //failed to resize the dialog because of failure to initialise or something. ignore.
                    //potentially could unbind but can't guarantee that the modal will initialise in the future
                }
            });

			return $dialog;
		},

        getWidth: function(){
            let windowWidth = window.innerWidth;
            let modalWidth = 420;

            if(windowWidth > 576 ) {
                modalWidth = 420;
            }
            if(windowWidth > 768 ) {
                modalWidth = 668;
            }
            if(windowWidth > 992 ) {
                modalWidth = 892;
            }
            if(windowWidth > 1200 ) {
                modalWidth = 1000;
            }
            if(windowWidth > 1400 ) {
                modalWidth = 1200;
            }
            return modalWidth;
        },
		
		/* resize a given dialog to the correct max size for the window */
		resize: function($dialog) {

            var width = $dialog.dialog( "option", "width");

            //fix for small widths
            if ($(window).width() < width + 50) {
                $dialog.parent().css("width", "auto");
                $dialog.parent().css("max-width", "96%");
            } else if (width){
                $dialog.parent().css("max-width", width);
            }

            //fix for variable height
            //set to auto first so we can reliably calculate the content height
            $dialog.dialog("option", "height", "auto");
            var height = $dialog.parent().outerHeight();

            if (height >= $(window).height() * 0.75) {
                height = Math.round($(window).height() / 1.25);
                $dialog.dialog("option", "height", height);
            }
            $dialog.dialog("option", "position", { my: "top", at: "top+10%", of: window });

		},

        scrollAdjust: function($dialog){
            $dialog.dialog("option", "position", { my: "top", at: "top+10%", of: window });
        }


};

})();
var mdl = ele.modal;
$(function() {
	ele.modal.init();
});
